import { useMemo } from 'react';

import { orderBy } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';
import { useQueryGetStoredTags } from 'api/queries/getStoredTags.query';

import SelectListWithCreate from 'components/common/selectListWithCreate/selectListWithCreate';

import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Tags = () => {
    const { customerId } = useUserHook();
    const { project, contract } = useProjectTreeStore();
    const { data: tags } = useQueryGetStoredTags({
        enabled: true,
        customerId,
        projectId: project?.id,
        contractId: contract?.id,
    });
    const { setValue, watch, control } = useFormContext<Risk>();

    const options = useMemo<ISelectOption<string>[]>(
        () =>
            tags
                ? orderBy(
                      tags.map((item) => ({ label: item.name, value: item.name })),
                      [(item: any) => item['label'].toLowerCase()],
                      ['asc'],
                  )
                : [],
        [tags],
    );

    const onChange = (value: any) => {
        value &&
            setValue(
                'tags',
                value.map((item) => ({ name: item.value })),
                { shouldDirty: true },
            );
    };

    const value = useMemo(() => {
        const value = watch('tags');
        if (value) {
            return value.map((item) => ({ label: item.name, value: item.name }));
        } else {
            return [];
        }
    }, [watch('tags'), options]);

    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Tags:</div>
            <div className={classes.content}>
                <Controller
                    render={({ field }) => (
                        <SelectListWithCreate
                            {...field}
                            value={value}
                            onChange={onChange}
                            options={options}
                            id={'cardModalTags'}
                        />
                    )}
                    name={`tags`}
                    control={control}
                />
            </div>
        </div>
    );
};
